module.exports = __webpack_public_path__ + "img/NO.d6fb6a36.svg";